import { OFFER_CATEGORY } from 'shared/constants/offer-categories';
import { GameTileResponseDto } from 'shared/interfaces/game/game-tile-response.dto';
import { GameCardDataProps } from 'src/components/GameCard/GameCard';

/**
 * Maps a signed game tile from the recommendation engine to the data the GameCard renders,
 * preserving the signature and encrypted details so the card can open the game view on click.
 */
export function mapGameTileResponseToGameCardData(gameTile: GameTileResponseDto): GameCardDataProps {
  return {
    cardType: 'game',
    title: gameTile.name ?? '',
    partnerName: gameTile.partnerName,
    points: gameTile.gameTile.payoutPoints,
    xp: gameTile.gameTile.xp,
    rating: gameTile.gameTile.rating ?? 0,
    imageUrl: gameTile.tileImage ?? gameTile.iconImage ?? undefined,
    gameId: gameTile.gameId,
    osTypeId: gameTile.osTypeId,
    categories: gameTile.categories ?? [OFFER_CATEGORY.Games],
    signature: gameTile.signature,
    gameTileDetailsDto: gameTile.gameTile.gameTileDetailsDto,
    isNew: gameTile.isNew === true,
  };
}
